export enum DocumentSettingsTabs {
    BOOKMARKS = 0,
    DIRECTLINK = 1,
    PDFCONVERTER = 2,
    ASSESSMENTANDDISTRIBUTION = 3
  }